import React, { FC, useState } from 'react';
import { PaymentApi } from '@api/payment';
import UiButton from '@ui/Button';
import { I18n } from 'react-redux-i18n';
import { BEMHelper } from '@utils/customBEMHelper';
import { IPaymentOptions } from '../interfaces';

import './styles.scss';
import { getTimeZone } from '@utils/date';

const classes = new BEMHelper({
  name: 'payment-option-stripe',
});

const StripeButton: FC<IPaymentOptions> = ({
  plan,
  receiverId,
  phone,
  email,
  isValid,
  onClickPay,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleClickPay = async () => {
    onClickPay();
    if (isLoading || !isValid) return;

    setIsLoading(true);
    const { url } = await PaymentApi.initPayment({
      tel: phone,
      receiverId,
      plan,
      email,
      method: 'stripe',
      timezone: getTimeZone(),
    });
    setIsLoading(false);
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <UiButton
      onClick={handleClickPay}
      disabled={isLoading}
      color="green"
      size="big"
      className={classes('btn')}
      test-id="paymentOption-button-stripe"
    >
      {I18n.t('other.payByCard')}
    </UiButton>
  );
};

export default StripeButton;
